
// 登录
import fetch from '../fetch';

import {
  // 积分兑换
  EXCHANGE_ORDER_LIST,
  EXCHANGE_ORDER_DETAIL,
  EXCHANGE_CHANGE_ORDER_STATUS,
  EXCHANGE_LOGINSTICS_LIST,
  EXCHANGE_GOODS_LIST,
  ADD_EXCHANGE_GOODS,
  GOODS_DETAIL,
  UPDATE_GOODS_STATUS,
  UPDATE_EXCHANGE_GOODS,
  EXCHANGE_GIFTS_LIST,
  UPDATE_GOODS_STATUS_BATCH,
  // 广告
  CMAD_EDITAD_NEWAD,
  CMAD_EDITAD_EDITAD,
  CMAD_EDITAD_SUBMITAD,
  DD_VALUE_BY_KEY,
  COM_BO_DATA,
  DD_VALUE_GET_AD_LIST,
  CMAD_GET_AD_DETAIL,
  CMAD_DELETE_AD,
  CMAD_UPDATE_AD_STATUS,
  CMAD_GET_AD_DETAIL_BY_POSITION,
  CMAD_UPDATE_BANNER_STATUS,
  CMAD_DELETE_BANNER,
  // 新品试用
  PRODUCT_ACTIVITY_LIST,
  PRODUCT_ACTIVITY_LIST_MIDEA,
  PRODUCT_ACTIVITY_INTRODUCED,
  PRODUCT_ACTIVITY_STOP_MIDEA,
  PRODUCT_ACTIVITY_PUBLISH_MIDEA,
  PRODUCT_ACTIVITY_DETAIL,
  PRODUCT_ACTIVITY_DETAIL_MIDEA,
  PRODUCT_ACTIVITY_SAVE,
  PRODUCT_ACTIVITY_SAVE_MIDEA,
  PRODUCT_ACTIVITY_DELETED,
  PRODUCT_ACTIVITY_DELETED_MIDEA,
  PRODUCT_ACTIVITY_UPDATE,
  PRODUCT_ORDER_LIST,
  PRODUCT_ORDER_DELIVER,
  PRODUCT_ORDER_EVALUATE_EDIT,
  PRODUCT_PRODUCT_ACTIVITY_REPORT,
  PRODUCT_ORDER_EVALUATE,
  PRODUCT_ORDER_EXAMINE,
  PRODUCT_ORDER_GET_QUESTION_BY_ID,
  PRODUCT_ACTIVITY_REPORE_DELLETED,
  PRODUCT_ACTIVITY_REPORE_GET_BY_ID,
  // 短链管理
  GET_SHORT_LINK_LIST,
  SHORT_LINK_SAVE,
  SHORT_LINK_DELETE,
  SHORT_LINK_DETAIL,
  PVUV_DATA_LIST,
  PVUV_DATA_TOTAL,
  EVENT_GET_PV_UV_WITH_GROUP_BY,
  // 短信管理
  SMS_ACTIVITY_EVENTS,
  SMS_DELETE_BY_ID,
  GET_EVENT_DETAIL,
  SMS_GET_ORG_MSG,
  SMS_TEST_SMS,
  SMS_CONFIG,
  SMS_BIG_DATA_GROUP_LIST,
  SMS_FIRST_MOBILE,
  SMS_STOP_SEND_TASK_INFO,
  // 短信模板
  CMSMS_NEW_TEMPLATE_LIST,
  CMSMS_NEW_TEMPLATE_SAVE_OR_UPDATE,
  CMSMS_NEW_TEMPLATE_DETAIL,
  CMSMS_NEW_TEMPLATE_DELETE,
  CMSMS_NEW_TEMPLATE_VARIABLE_LIST,
  // 消息中心
  MSG_CENTER_LIST,
  MSG_CHANNEL_LIST,
  MSG_CENTER_CREATE,
  MSG_CENTER_EDIT,
  MSG_CENTER_SEND,
  MSG_CENTER_DELETE,
  MSG_CENTER_DETAIL,
  // 微信模板消息
  GET_UPKEEP_CONFIG_LIST,
  // 优惠券管理
  COUPON_RULE_LIST,
  COUPON_RULE_DETAIL,
  COUPON_RULE_ADD,
  COUPON_RULE_OPT_ADD,
  COUPON_RULE_EDIT,
  COUPON_RULE_OPT_EDIT,
  COUPON_ACTIVITY_LIST,
  COUPON_ACTIVITY_ENABLE,
  COUPON_ACTIVITY_DETAIL,
  COUPON_ACTIVITY_ADD,
  COUPON_ACTIVITY_EDIT,
  COUPON_ORDER_LIST,
  COUPON_ORDER_SEND,
  COUPON_ORDER_DETAIL,
  COUPON_CANCEL_TO_VOID,
  // 受众管理
  GET_AUDIENCE_LABEL_LIST,
  INSERT_OR_UPDATE_LABEL_INFO,
  GET_LABEL_INFO,
  DELETE_LABEL_INFO,
  // 受众人群详情报表
  LABEL_BOARD_TREND,
  LABEL_BOARD_LIST,
  LABEL_BOARD_SOURCE_DISTRIIBUTED,
  LABEL_BOARD_LEVEL_DISTRIBUTED,
  PRECISION_PROMOTE_GET_CMIMP_GAME_LIST,
  SUPPORT_GET_PRODUCT_TYPE_XYJ,
  // 引用大数据人群
  LABEL_SELECT_ODS_GROUP_LIST,
  LABEL_SYNE_ODS_GROUP,
  // 投放效果报表
  PROMOTE_BOARD_OVERVIEW,
  FUNNEL_GET_EVENT_TREE,
  FUNNEL_GET_STEPS,
  PROMOTE_FUNNEL_SETTING_SAVE,
  PROMOTE_FUNNEL_SETTING_DELETE,
  PROMOTE_FUNNEL_SETTING_LIST,
  PROMOTE_BOARD_FUNNEL_CONVER_SION_RATE,
  PROMOTE_BOARD_FUNNEL_TENDENCY,
  PROMOTE_BOARD_ALL_OVER_VIEW,
  PROMOTE_BOARD_ALL_OVERVIEW_CHART,
  PROMOTE_TASK_PAGE,
  DA_EVENT_GET_EVENTS,
  // 精准投放管理
  PROMOTE_PRECISION_PROMOTE_PAGE,
  PROMOTE_PRECISION_PROMOTE_LIST,
  PROMOTE_PRECISION_PROMOTE_DETAIL,
  PROMOTE_PRECISION_PROMOTE_ADD,
  PROMOTE_PRECISION_PROMOTE_UPDATE,
  PROMOTE_PRECISION_PROMOTE_DELETE,
  PROMOTE_PRECISION_GET_CHANNEL,
  GET_PRECISION_AD_LIST,
  PROMOTE_PRECISION_GET_PREDICT_LABEL_COUNT,
  PROMOTE_REECISION_GET_PREDICT_BEGIN_TIME,
  SELECT_PROMOTE_LABEL,
  LABEL_INSERT_OR_UPDATE_LABEL_TYPE,
  LABEL_GET_LABEL_TYPE_RELATION,
  LABEL_SELECT_LABEL_TYPE_LIST,
  LABEL_DELETE_LABEL_TYPE,
  LABEL_INDSERT_OR_UPDATE_LABEL_RELATION,
  MSG_GET_TEMPLATE_LIST,
  PRECISION_PROMOTE_ADD_MASTER_SLAVE_RULE,
  // 自动化营销策略
  WCP_MSG_GET_MATERIAL_LIST,
  PROMOTE_PRECISION_PROMOTE_UPDATE_ENABLE_STATE,
  PROMOTE_BOARD_GET_ACHIEVE_TOTAL_NUM,
  PROMOTE_BOARD_GET_ACHIEVE_CHART_LINE,
  // 图文专题
  PIC_TOPIC_LIST,
  PIC_TOPIC_ADD,
  PIC_TOPIC_UPDATE,
  PIC_TOPIC_STATUS_UPDATE,
  PIC_TOPIC_DETAIL,
  UPLOAD_IMG_SAVE,
  PICTURE_TOPIC_MATERIALS_PAGE,
  PICTURE_TOPIC_DELETE_MATERIAL,
  PICTURE_TOPIC_DELETE_MATERIAL_TYPE,
  PICTURE_TOPIC_EDIT_MATERIAL,
  PICTURE_TOPIC_EDIT_MATERIAL_TYPE,
  // 推送管理
  SAVE_PUSH_MSG_URL,
  UPDATE_PUSH_MSG_URL,
  COMMIT_ADV_MSG_ADD_URL,
  COMMIT_ADV_MSG_EDIT_URL,
  COMMIT_PUSH_MSG_ADD_URL,
  COMMIT_PUSH_MSG_EDIT_URL,
  DELETE_PUSH_MSG_URL,
  INVALID_PUSH_MSG_URL,
  LIST_PUSH_MSG_URL,
  GET_PUSH_MSG_URL,
  PUSH_APP_MSG_URL,
  PUSH_APP_MSG_EDIT_URL,
  USER_GROUP_LIST_URL,
  LOAD_TAG_USER_ADD_URL,
  LOAD_TAG_USER_EDIT_URL,
  SAVA_TARGET_AUDITOR_URL,
  PUSH_USER_COUNT_URL,
  // 广告管理
  ADV_ADD_URL,
  SAVA_TARGET_GG_AUDITOR_URL,
  ADV_DELETE_URL,
  ADV_UPDATE_URL,
  ADV_UPDATE_WEIGHT_URL,
  DIRECTIONAL_TO_MOBILE,
  GET_UPDATED_LOG,
  ADVERTISEMENT_COPY,
  ADVFAIL_STOP_URL,
  QUERY_ADV_URL,
  GET_AD_LIST,
  QUERY_ADV_ORDER_URL,
  GET_ADV_DETAIL_URL,
  // 广告位管理
  ADV_POSITION_ADD_URL,
  ADV_POSITION_DELETE_URL,
  ADV_POSITION_UPDATE_URL,
  ADV_POSITION_LIST_URL,
  QUERY_ADV_POS_URL,
  GET_ADV_POS_DETAIL_URL,
  PAGE_GET_TEMPLATE_LIST,
  PAGE_GET_ASSEMBLY_LIST,
  PAGE_UPDATE,
  PAGE_SAVE,
  PAGE_LIST,
  USER_CATEGORY_LIST,
  PAGE_OPERATE,
  PAGE_COPY,
  PAGE_INVALID,
  PAGE_DELETE,
  PAGE_PUBLISH,
  PAGE_CANCEL_PUBLISHED,
  PAGE_SCHEDULED_PUBLISH,
  PAGE_DRAFT,
  PAGE_AUDIT,
  PAGE_PUBLISH_EDIT,
  GET_PUBLISH_PAGE_BY_PRODUCT,
  PAGE_CANCEL_PUBLISHED_EDIT,
  PAGE_SCHEDULED_PUBLISH_EDIT,
  CHECK_DETAIL,
  PAGE_GET_CATEGORY_LIST,
  PAGE_GET_PRODUCT_LIST,
  PAGE_GET_ARTICLE_LIST,
  PAGE_GET_ARTICLE_DETAL,
  ARTICLE_RECOMMENDED,
  PAGE_DETAIL,
  GET_DCP_BRAND,
  PAGE_GET_NAV_LIST,
  DCP_ARTICLE_LIST,
  DCP_SPECIAL_TOPIC_LIST,
  DCP_TOPIC_ARTICLE_LIST,
  DCP_ACCOUNT_LIST,
  DCP_DEPARTMENT_LIST
} from '../url';

// 推送管理请求header
const headers = {
  'Content-Type': 'application/json',
};

const HEADERS_DCPPC = {
  'Content-Type': 'application/json',
  'sourceSystem': 'dcppc'
};

/**
 * 积分兑换订单列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function exchangeOrderList(data) {
  return fetch({
    url: EXCHANGE_ORDER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 积分兑换订单详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function exchangeOrderDetail(data) {
  return fetch({
    url: EXCHANGE_ORDER_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 积分兑换订单详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function exchangeChangeOrderStatus(data) {
  return fetch({
    url: EXCHANGE_CHANGE_ORDER_STATUS,
    method: 'post',
    data: data
  });
};

/**
 * 获取物流公司接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function exchangeGetLoginsticsList(data) {
  return fetch({
    url: EXCHANGE_LOGINSTICS_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 积分兑换商品列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function exchangeGoodsList(data) {
  return fetch({
    url: EXCHANGE_GOODS_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新建积分兑换商品
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addExchangeGoods(data) {
  return fetch({
    url: ADD_EXCHANGE_GOODS,
    method: 'post',
    data: data
  });
};

/**
 * 积分兑换商品详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function goodsDetail(data) {
  return fetch({
    url: GOODS_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 修改积分兑换商品状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateGoodsStatus(data) {
  return fetch({
    url: UPDATE_GOODS_STATUS,
    method: 'post',
    data: data
  });
};
/**
 * 修改积分兑换商品
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateExchangeGoods(data) {
  return fetch({
    url: UPDATE_EXCHANGE_GOODS,
    method: 'post',
    data: data
  });
};

/**
 * 第三方商品列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function thirdPartyGiftsList(data) {
  return fetch({
    url: EXCHANGE_GIFTS_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 修改积分兑换商品状态-批量修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateGoodsStatusBatch(data) {
  return fetch({
    url: UPDATE_GOODS_STATUS_BATCH,
    method: 'post',
    data: data
  });
};

/**
 * 提交/暂存广告信息
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editAdSubmit(data, id) {
  let url;
  if (id) {
    // 编辑
    url = CMAD_EDITAD_EDITAD;
  } else {
    // 新增
    url = CMAD_EDITAD_NEWAD;
  };
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 广告信息最终提交
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editAdSubmitLast(data) {
  return fetch({
    url: CMAD_EDITAD_SUBMITAD,
    method: 'post',
    data: data
  });
};

/**
 * 投放渠道和抵达位置
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dictSelectList(data) {
  return fetch({
    url: DD_VALUE_BY_KEY,
    method: 'get',
    params: data
  });
};

/**
 * 精准投放检索服务号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function comboData(data) {
  return fetch({
    url: COM_BO_DATA,
    method: 'get',
    params: data
  });
};

/**
 * 投放渠道和抵达位置
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAdList(data) {
  return fetch({
    url: DD_VALUE_GET_AD_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 获取单条广告详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAdDetail(data) {
  return fetch({
    url: CMAD_GET_AD_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 删除广告
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteAd(data) {
  return fetch({
    url: CMAD_DELETE_AD,
    method: 'get',
    params: data
  });
};

/**
 * 广告启用/禁用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateAdStatus(data) {
  return fetch({
    url: CMAD_UPDATE_AD_STATUS,
    method: 'get',
    params: data
  });
};

/**
 * 根据展示位置查询广告详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAdDetailByPosition(data) {
  return fetch({
    url: CMAD_GET_AD_DETAIL_BY_POSITION,
    method: 'get',
    params: data,
    isNoMsg: true
  });
};

/**
 * 广告banner启用/禁用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateBannerStatus(data) {
  return fetch({
    url: CMAD_UPDATE_BANNER_STATUS,
    method: 'get',
    params: data
  });
};

/**
 * 广告banner物理删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteBanner(data) {
  return fetch({
    url: CMAD_DELETE_BANNER,
    method: 'get',
    params: data
  });
};

/** 新品试用 */

/**
 * 新品试用活动列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductActivityList(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用活动列表(midea)
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductActivityListMidea(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_LIST_MIDEA,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用活动发布
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productActivityIntroduced(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_INTRODUCED,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用活动发布
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productActivityIntroducedMidea(params, type) {
  return fetch({
    url: type === 1 ? PRODUCT_ACTIVITY_STOP_MIDEA : PRODUCT_ACTIVITY_PUBLISH_MIDEA,
    method: 'get',
    params: params
  });
};

/**
 * 新品试用活动详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductActivityDetail(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 新品试用活动详情(midea)
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductActivityDetailMidea(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_DETAIL_MIDEA,
    method: 'get',
    params: data
  });
};

/**
 * 编辑新品试用活动
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productActivityUpdate(data, id) {
  let url;
  if (id) {
    url = PRODUCT_ACTIVITY_UPDATE;
    data.id = id;
  } else {
    url = PRODUCT_ACTIVITY_SAVE;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 编辑新品试用活动(midea)
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productActivityUpdateMidea(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_SAVE_MIDEA,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用活动删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deletedProductActivity(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_DELETED,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用活动删除(midea)
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deletedProductActivityMidea(params) {
  return fetch({
    url: PRODUCT_ACTIVITY_DELETED_MIDEA,
    method: 'delete',
    params: params
  });
};

/**
 * 新品试用订单列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductOrderList(data) {
  return fetch({
    url: PRODUCT_ORDER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用订单发货
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productOrderDeliver(data) {
  return fetch({
    url: PRODUCT_ORDER_DELIVER,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用报告-订单
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productActivityReport(data) {
  return fetch({
    url: PRODUCT_PRODUCT_ACTIVITY_REPORT,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用订单填写评测内容
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productOrderEvaluate(data, type) {
  let url;
  if (type === 'edit') {
    url = PRODUCT_ORDER_EVALUATE_EDIT;
  } else {
    url = PRODUCT_ORDER_EVALUATE;
  };
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用订单评价
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function productOrderExamine(data) {
  return fetch({
    url: PRODUCT_ORDER_EXAMINE,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用订单问题详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getQuestionsByid(data) {
  return fetch({
    url: PRODUCT_ORDER_GET_QUESTION_BY_ID,
    method: 'get',
    params: data
  });
};

/**
 * 新品试用报告-删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function reportDeletedByid(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_REPORE_DELLETED,
    method: 'post',
    data: data
  });
};

/**
 * 新品试用订单问题详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getReportGetByid(data) {
  return fetch({
    url: PRODUCT_ACTIVITY_REPORE_GET_BY_ID,
    method: 'get',
    params: data
  });
};

/**
 * 获取短链列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getShortLinkList(data) {
  return fetch({
    url: GET_SHORT_LINK_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 短链新增/编辑
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function saveShortLink(data) {
  return fetch({
    url: SHORT_LINK_SAVE,
    method: 'post',
    data: data
  });
};

/**
 * 短链删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteShortLink(data) {
  return fetch({
    url: SHORT_LINK_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 查询短链详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getShortLinkDetail(data) {
  return fetch({
    url: SHORT_LINK_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 查询PV/UV数据看板-广告/短链
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPvUvData(data) {
  return fetch({
    url: PVUV_DATA_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 分组获取短链、广告等事件pvuv总数
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPvUvWithGroupBy(data) {
  return fetch({
    url: EVENT_GET_PV_UV_WITH_GROUP_BY,
    method: 'post',
    data: data
  });
};

/**
 * 查询PV/UV总数-广告/短链
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPvUvTotalData(data) {
  return fetch({
    url: PVUV_DATA_TOTAL,
    method: 'post',
    data: data
  });
};

/**
 * 短信管理列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSmsList(data) {
  return fetch({
    url: SMS_ACTIVITY_EVENTS,
    method: 'post',
    data: data
  });
};

/**
 * 删除未投放的短信
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsDelById(data) {
  return fetch({
    url: SMS_DELETE_BY_ID,
    method: 'post',
    data: data
  });
};

/**
 * 获取单条短信详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsGetEventDetail(data) {
  return fetch({
    url: GET_EVENT_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 获取短信的发送主体
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsGetOrgMsg(data) {
  return fetch({
    url: SMS_GET_ORG_MSG,
    method: 'post',
    data: data
  });
};

/**
 * 发送测试短信
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function testSmsSend(data) {
  return fetch({
    url: SMS_TEST_SMS,
    method: 'post',
    data: data
  });
};

/**
 * 提交编辑批量短信
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsSubmit(data) {
  return fetch({
    url: SMS_CONFIG,
    method: 'post',
    data: data
  });
};

/**
 * 人群包列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsGetgroupList(data) {
  return fetch({
    url: SMS_BIG_DATA_GROUP_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 获取预览时人群包变量
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function smsFirstMobile(data) {
  return fetch({
    url: SMS_FIRST_MOBILE,
    method: 'post',
    data: data
  });
};

/**
 * 中止短信接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function stopSendTaskInfo(data) {
  return fetch({
    url: SMS_STOP_SEND_TASK_INFO,
    method: 'post',
    data: data
  });
};

/**
 * 模板列表查询
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTemplateList(data) {
  return fetch({
    url: CMSMS_NEW_TEMPLATE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 模板新增或编辑
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function templateSaveOrUpdate(data) {
  return fetch({
    url: CMSMS_NEW_TEMPLATE_SAVE_OR_UPDATE,
    method: 'post',
    data: data
  });
};

/**
 * 模板详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function templateDetail(data) {
  return fetch({
    url: CMSMS_NEW_TEMPLATE_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 删除模板
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function templateDelete(data) {
  return fetch({
    url: CMSMS_NEW_TEMPLATE_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 变量列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTemplateVariableList(data) {
  return fetch({
    url: CMSMS_NEW_TEMPLATE_VARIABLE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 消息中心-列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMsgCenterList(data) {
  return fetch({
    url: MSG_CENTER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 消息中心-渠道
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMsgChannelList(data) {
  return fetch({
    url: MSG_CHANNEL_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 消息中心-新建
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function createMsg(data) {
  return fetch({
    url: MSG_CENTER_CREATE,
    method: 'post',
    data: data
  });
};

/**
 * 消息中心-编辑
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editMsg(data) {
  return fetch({
    url: MSG_CENTER_EDIT,
    method: 'post',
    data: data
  });
};

/**
 * 消息中心-发送
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function sendMsg(params) {
  return fetch({
    url: MSG_CENTER_SEND + params,
    method: 'get',
  });
};

/**
 * 消息中心-删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteMsg(params) {
  return fetch({
    url: MSG_CENTER_DELETE + params,
    method: 'get',
  });
};

/**
 * 消息中心-详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMsgDetail(params) {
  return fetch({
    url: MSG_CENTER_DETAIL + params,
    method: 'get',
  });
};

/**
 * 查询优惠券规则列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponRuleList(data) {
  return fetch({
    url: COUPON_RULE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 查询优惠券规则详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponRuleDetail(data) {
  return fetch({
    url: COUPON_RULE_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 新增优惠券规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function createCouponRule(data) {
  return fetch({
    url: COUPON_RULE_ADD,
    method: 'post',
    data: data
  });
};

/**
 * 新增优惠券规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function optCreateCouponRule(data) {
  return fetch({
    url: COUPON_RULE_OPT_ADD,
    method: 'post',
    data: data
  });
};

/**
 * 编辑优惠券规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editCouponRule(data) {
  return fetch({
    url: COUPON_RULE_EDIT,
    method: 'post',
    data: data
  });
};

/**
 * 编辑优惠券规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function optEditCouponRule(data) {
  return fetch({
    url: COUPON_RULE_OPT_EDIT,
    method: 'post',
    data: data
  });
};

/**
 * 获取优惠券活动列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponActivityList(data) {
  return fetch({
    url: COUPON_ACTIVITY_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 优惠券活动启用/停用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateCouponActivityStatus(data) {
  return fetch({
    url: COUPON_ACTIVITY_ENABLE,
    method: 'post',
    data: data
  });
};

/**
 * 获取优惠券活动详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponActivityDetail(data) {
  return fetch({
    url: COUPON_ACTIVITY_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 创建优惠券活动
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function createCouponActivity(data) {
  return fetch({
    url: COUPON_ACTIVITY_ADD,
    method: 'post',
    data: data
  });
};

/**
 * 编辑优惠券活动
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editCouponActivity(data) {
  return fetch({
    url: COUPON_ACTIVITY_EDIT,
    method: 'post',
    data: data
  });
};

/**
 * 优惠券流水列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponOrderList(data) {
  return fetch({
    url: COUPON_ORDER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 优惠券流水发货
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function sendCouponOrder(data) {
  return fetch({
    url: COUPON_ORDER_SEND,
    method: 'post',
    data: data
  });
};

/**
 * 优惠券流水详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCouponOrderDetail(data) {
  return fetch({
    url: COUPON_ORDER_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 优惠券流水-作废
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function couponCancel(data) {
  return fetch({
    url: COUPON_CANCEL_TO_VOID,
    method: 'get',
    params: data
  });
};

/**
 * 查询保养配置列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUpkeepConfigList(data) {
  return fetch({
    url: GET_UPKEEP_CONFIG_LIST,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 查询受众人群管理列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectLabelList(data) {
  return fetch({
    url: GET_AUDIENCE_LABEL_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增编辑标签
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateLabelInfo(data) {
  return fetch({
    url: INSERT_OR_UPDATE_LABEL_INFO,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 详情页 - 概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function promoteBoardOverview(data) {
  return fetch({
    url: PROMOTE_BOARD_OVERVIEW,
    method: 'get',
    params: data
  });
};

/**
 * 查询标签详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLabelInfo(data) {
  return fetch({
    url: GET_LABEL_INFO,
    method: 'post',
    data: data
  });
};

/**
 * 删除标签
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteLabelInfo(data) {
  return fetch({
    url: DELETE_LABEL_INFO,
    method: 'post',
    data: data
  });
};

/**
 * 受众人群详情报表 - 人群数量趋势
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function labelBoardTrend(data) {
  return fetch({
    url: LABEL_BOARD_TREND,
    method: 'post',
    data: data
  });
};

/**
 * 受众人群详情报表 - 人群明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function labelBoardList(data) {
  return fetch({
    url: LABEL_BOARD_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 受众人群详情报表 - 来源人群分布
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function labelBoardSourceDistributed(data) {
  return fetch({
    url: LABEL_BOARD_SOURCE_DISTRIIBUTED,
    method: 'post',
    data: data
  });
};

/**
 * 受众人群详情报表 - 等级人群分布
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function labelBoardLevelDistributed(data) {
  return fetch({
    url: LABEL_BOARD_LEVEL_DISTRIBUTED,
    method: 'post',
    data: data
  });
};

/**
 * 受众人群详情报表 - 获取活动平台游戏列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCmimpGameList(data) {
  return fetch({
    url: PRECISION_PROMOTE_GET_CMIMP_GAME_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 洗悦家产品大类接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductTypeXyj(data) {
  return fetch({
    url: SUPPORT_GET_PRODUCT_TYPE_XYJ,
    method: 'get',
    params: data
  });
};

/**
 * 大数据人群列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectOdsGroupList(data) {
  return fetch({
    url: LABEL_SELECT_ODS_GROUP_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 引用大数据人群
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function syneOdsGroup(data) {
  return fetch({
    url: LABEL_SYNE_ODS_GROUP,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 根据appId获取漏斗事件树
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getEventTree(data) {
  return fetch({
    url: FUNNEL_GET_EVENT_TREE,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 根据appId获取漏斗步骤
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getFunnelSteps(data) {
  return fetch({
    url: FUNNEL_GET_STEPS,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 保存漏斗设置
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelSettingSave(data) {
  return fetch({
    url: PROMOTE_FUNNEL_SETTING_SAVE,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 删除漏斗设置
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelSettingDelete(data) {
  return fetch({
    url: PROMOTE_FUNNEL_SETTING_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 根据prid获取设置的漏斗列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelSettingList(data) {
  return fetch({
    url: PROMOTE_FUNNEL_SETTING_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 投放效果报表 获取漏斗转化率
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelConversionRate(data) {
  return fetch({
    url: PROMOTE_BOARD_FUNNEL_CONVER_SION_RATE,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 获取漏斗趋势折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelTendency(data) {
  return fetch({
    url: PROMOTE_BOARD_FUNNEL_TENDENCY,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 获取漏斗趋势折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelAllOverview(data) {
  return fetch({
    url: PROMOTE_BOARD_ALL_OVER_VIEW,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 获取漏斗趋势折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function funnelAllOverviewChart(data) {
  return fetch({
    url: PROMOTE_BOARD_ALL_OVERVIEW_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 获取投放任务分页列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function promoteTaskPage(data) {
  return fetch({
    url: PROMOTE_TASK_PAGE,
    method: 'post',
    data: data
  });
};

/**
 * 投放效果报表 获取页面关联的事件列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function daGetEvents(data) {
  return fetch({
    url: DA_EVENT_GET_EVENTS,
    method: 'post',
    data: data
  });
};

/**
 * 获取精确投放列表数据-分页
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromotePage(data) {
  return fetch({
    url: PROMOTE_PRECISION_PROMOTE_PAGE,
    method: 'post',
    data: data
  });
};

/**
 * 获取精确投放列表数据
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteList(data) {
  return fetch({
    url: PROMOTE_PRECISION_PROMOTE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 获取精确投放列表数据 - 详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteDetail(data) {
  return fetch({
    url: PROMOTE_PRECISION_PROMOTE_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 获取精确投放列表数据 - 新增 - 修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteAdd(data, prid) {
  let url = null;
  if (prid) {
    url = PROMOTE_PRECISION_PROMOTE_UPDATE;
  } else {
    url = PROMOTE_PRECISION_PROMOTE_ADD;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 获取精确投放列表数据 - 删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteDelete(data) {
  return fetch({
    url: PROMOTE_PRECISION_PROMOTE_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 根据进准投放ID获取关联的渠道
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteChannel(data) {
  return fetch({
    url: PROMOTE_PRECISION_GET_CHANNEL,
    method: 'get',
    params: data
  });
};

/**
 * 根据进准投放ID获取关联的渠道
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPrecisionAdList(data, isBrandInit) {
  return fetch({
    url: GET_PRECISION_AD_LIST,
    method: 'get',
    params: data,
    // 是否自定义品牌
    brandInit: isBrandInit,
    testerUrl: '/test/'
  });
};

/**
 * 获取预计标签投放人数
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPredictLabelCount(data) {
  return fetch({
    url: PROMOTE_PRECISION_GET_PREDICT_LABEL_COUNT,
    method: 'post',
    data: data
  });
};

/**
 * 获取预计开始投放时间
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPredictBeginTime(data) {
  return fetch({
    url: PROMOTE_REECISION_GET_PREDICT_BEGIN_TIME,
    method: 'get',
    params: data
  });
};

/**
 * 投放人群标签查询(只查询投放过的标签)
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectPromoteLabel(data) {
  return fetch({
    url: SELECT_PROMOTE_LABEL,
    method: 'post',
    data: data
  });
};

/**
 * 新增或修改标签组
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateLabelType(data) {
  return fetch({
    url: LABEL_INSERT_OR_UPDATE_LABEL_TYPE,
    method: 'post',
    data: data
  });
};

/**
 * 根据内容id查询标签列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLabelRelation(data) {
  return fetch({
    url: LABEL_GET_LABEL_TYPE_RELATION,
    method: 'post',
    data: data
  });
};

/**
 * 查询标签列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectLabelTypeList(data) {
  return fetch({
    url: LABEL_SELECT_LABEL_TYPE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 删除标签组
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteLabelType(data) {
  return fetch({
    url: LABEL_DELETE_LABEL_TYPE,
    method: 'post',
    data: data
  });
};

/**
 * 绑定标签到内容
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateLabelRelation(data) {
  return fetch({
    url: LABEL_INDSERT_OR_UPDATE_LABEL_RELATION,
    method: 'post',
    data: data
  });
};

/**
 * 获取模板消息模板列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMsgTemplateList(data) {
  return fetch({
    url: MSG_GET_TEMPLATE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增主从精准投放策略
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addMasterSlaveRule(data) {
  return fetch({
    url: PRECISION_PROMOTE_ADD_MASTER_SLAVE_RULE,
    method: 'post',
    data: data
  });
};

/**
 * 获取48小时推送素材列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMaterialList(data) {
  return fetch({
    url: WCP_MSG_GET_MATERIAL_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 精准投放启用/停用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function precisionPromoteUpdateEnableStatus(data) {
  return fetch({
    url: PROMOTE_PRECISION_PROMOTE_UPDATE_ENABLE_STATE,
    method: 'post',
    data: data
  });
};

/**
 * 获取触达人群总数
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAchieveTotalNum(data) {
  return fetch({
    url: PROMOTE_BOARD_GET_ACHIEVE_TOTAL_NUM,
    method: 'GET',
    params: data
  });
};

/**
 * 获取触达人群趋势折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAchieveChartLine(data) {
  return fetch({
    url: PROMOTE_BOARD_GET_ACHIEVE_CHART_LINE,
    method: 'post',
    data: data
  });
};

/**
 * 请求图文专题列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPicTopicList(data) {
  return fetch({
    url: PIC_TOPIC_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增图文/ 编辑图文
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addPicTopic(data, id) {
  let url = PIC_TOPIC_ADD;
  if (id) {
    // 编辑
    url = PIC_TOPIC_UPDATE;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 启用/禁用图文
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updatePicTopicStatus(data) {
  return fetch({
    url: PIC_TOPIC_STATUS_UPDATE,
    method: 'get',
    params: data
  });
};

/**
 * 图文详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPicTopicDetail(data) {
  return fetch({
    url: PIC_TOPIC_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 保存图片
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function savePicTopicImage(data) {
  return fetch({
    url: UPLOAD_IMG_SAVE,
    method: 'post',
    data: data
  });
};

/**
 * 分页素材
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMaterialsPage(data) {
  return fetch({
    url: PICTURE_TOPIC_MATERIALS_PAGE,
    method: 'post',
    data: data
  });
};

/**
 * 删除素材
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteMaterial(data) {
  return fetch({
    url: PICTURE_TOPIC_DELETE_MATERIAL,
    method: 'get',
    params: data
  });
};

/**
 * 删除素材分类
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteMaterialType(data) {
  return fetch({
    url: PICTURE_TOPIC_DELETE_MATERIAL_TYPE,
    method: 'get',
    params: data
  });
};

/**
 * 分页素材
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editOrUpdateMaterial(data) {
  return fetch({
    url: PICTURE_TOPIC_EDIT_MATERIAL,
    method: 'post',
    data: data
  });
};

/**
 * 改素材分类名称
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editMaterialType(data) {
  return fetch({
    url: PICTURE_TOPIC_EDIT_MATERIAL_TYPE,
    method: 'get',
    params: data
  });
};

/**
 * 保存推送信息至草稿状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function savePushMsg(data, system, userName) {
  return fetch({
    url: SAVE_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName
    }
  });
};

/**
 * 保存推送信息至草稿状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updatePushMsg(data, system, userName) {
  return fetch({
    url: UPDATE_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName
    }
  });
};

/**
 * 提交推送信息 新增页
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commitAdvMsgAdd(data) {
  return fetch({
    url: COMMIT_ADV_MSG_ADD_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 提交广告信息 编辑页
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commitAdvMsgEdit(data) {
  return fetch({
    url: COMMIT_ADV_MSG_EDIT_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 提交广告信息 新增页
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commitPushMsgAdd(data) {
  return fetch({
    url: COMMIT_PUSH_MSG_ADD_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 提交推送信息 编辑页
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commitPushMsgEdit(data) {
  return fetch({
    url: COMMIT_PUSH_MSG_EDIT_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 删除推送信息
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deletePushMsg(data) {
  return fetch({
    url: DELETE_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 作废推送信息
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function invalidPushMsg(data) {
  return fetch({
    url: INVALID_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: headers
  });
};

/**
 * 推送信息列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function listPushMsg(data) {
  return fetch({
    url: LIST_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: HEADERS_DCPPC
  });
};

/**
 * 获取推送信息
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPushMsg(data) {
  return fetch({
    url: GET_PUSH_MSG_URL,
    method: 'post',
    data: data,
    headers: headers,
  });
};

/**
 * 推送预览
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function pushAppMsg(data, userName) {
  return fetch({
    url: PUSH_APP_MSG_URL,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
  });
};

/**
 * 推送预览
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function pushAppMsgEdit(data, userName) {
  return fetch({
    url: PUSH_APP_MSG_EDIT_URL,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
  });
};

/**
 * 获取用户标签
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCrowdList(requestData) {
  return fetch({
    url: USER_GROUP_LIST_URL,
    method: 'get',
    params: requestData,
    headers: headers,
    testerUrl: '/test/',
  });
};

/**
 * 同步标签用户
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function loadTagUserAdd(data) {
  return fetch({
    url: LOAD_TAG_USER_ADD_URL,
    method: 'post',
    data: data,
    headers: headers,
  });
};

/**
 * 同步标签用户
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function loadTagUserEdit(data) {
  return fetch({
    url: LOAD_TAG_USER_EDIT_URL,
    method: 'post',
    data: data,
    headers: headers,
  });
};

/**
 * 保存推送审核人
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function savaTargetAuditor(data) {
  return fetch({
    url: SAVA_TARGET_AUDITOR_URL,
    method: 'post',
    data: data,
    headers: headers,
  });
};

/**
 * 获取推送预计人数
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function pushUserCount(data) {
  return fetch({
    url: PUSH_USER_COUNT_URL,
    method: 'post',
    data: data,
    headers: headers,
  });
};

// 广告（位）管理---begin
function getAdvPositionList(requestData) {
  return fetch({
    url: ADV_POSITION_LIST_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function advPositionDelete(requestData) {
  return fetch({
    url: ADV_POSITION_DELETE_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function advPositionAdd(requestData, system, userName) {
  return fetch({
    url: ADV_POSITION_ADD_URL,
    method: 'post',
    data: requestData,
    testerUrl: '/test/',
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName,
    },
  });
};

function advPositionUpdate(requestData, system, userName) {
  return fetch({
    url: ADV_POSITION_UPDATE_URL,
    method: 'post',
    data: requestData,
    testerUrl: '/test/',
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName,
    },
  });
};

function advPositionList(requestData) {
  return fetch({
    url: ADV_POSITION_LIST_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function getAdvPosDetail(requestData) {
  return fetch({
    url: GET_ADV_POS_DETAIL_URL,
    method: 'post',
    data: requestData,
    testerUrl: '/test/',
    headers: headers
  });
};

function getAdvDetail(requestData) {
  return fetch({
    url: GET_ADV_DETAIL_URL,
    method: 'post',
    data: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

function advAdd(requestData, system, userName) {
  return fetch({
    url: ADV_ADD_URL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

function savaTargetGgAuditor(requestData) {
  return fetch({
    url: SAVA_TARGET_GG_AUDITOR_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function advDelete(requestData) {
  return fetch({
    url: ADV_DELETE_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function advUpdate(requestData, system, userName) {
  return fetch({
    url: ADV_UPDATE_URL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'sourceSystem': system,
      'currentUserId': userName
    },
    testerUrl: '/test/'
  });
};

function updateAdWeight(requestData, userName) {
  return fetch({
    url: ADV_UPDATE_WEIGHT_URL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
  });
};
  
function directionalToMobile(requestData, userName) {
  return fetch({
    url: DIRECTIONAL_TO_MOBILE,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

function getUpdatedLog(requestData, userName) {
  return fetch({
    url: GET_UPDATED_LOG,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

function advertisementCopy(requestData, userName) {
  return fetch({
    url: ADVERTISEMENT_COPY,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
	  testerUrl: '/test/'
  });
};

function advReviewStop(requestData) {
  return fetch({
    url: ADVFAIL_STOP_URL,
    method: 'post',
    data: requestData,
    headers: headers
  });
};

function queryAdvList(requestData, userName) {
  return fetch({
    url: QUERY_ADV_URL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

function getAdvList(requestData, userName) {
  return fetch({
    url: GET_AD_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

function queryAdvOrderList(requestData, userName) {
  return fetch({
    url: QUERY_ADV_ORDER_URL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
  });
};

function queryAdvPosList(requestData) {
  return fetch({
    url: QUERY_ADV_POS_URL,
    method: 'post',
    data: requestData,
    testerUrl: '/test/',
    headers: headers
  });
};
// ------广告（位）管理---end

// ------页面管理---start
// 页面管理-模板
function pageGetTemplateList(requestData) {
  return fetch({
    url: PAGE_GET_TEMPLATE_LIST,
    method: 'post',
    data: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

// 页面管理-组件查询
function pageGetAssemblyList(requestData) {
  return fetch({
    url: PAGE_GET_ASSEMBLY_LIST,
    method: 'post',
    data: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

// 页面管理-新增
function pageUpdate(requestData, userName) {
  return fetch({
    url: PAGE_UPDATE,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 页面管理-新增
function pageAdd(requestData, userName) {
  return fetch({
    url: PAGE_SAVE,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 页面管理-查询
function pageList(requestData) {
  return fetch({
    url: PAGE_LIST,
    method: 'post',
    data: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

// 页面管理-查询
function userCategoryList() {
  return fetch({
    url: USER_CATEGORY_LIST,
    method: 'get',
    headers: headers,
    testerUrl: '/test/'
  });
};

// 页面管理-操作
function pageOperate(requestData, userName) {
  return fetch({
    url: PAGE_OPERATE,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-复制
function pageCopy(requestData, userName) {
  return fetch({
    url: PAGE_COPY,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-作废
function pageInvalid(requestData, userName) {
  return fetch({
    url: PAGE_INVALID,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-作废
function pageDelete(requestData, userName) {
  return fetch({
    url: PAGE_DELETE,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-发布
function pagePublish(requestData, userName) {
  return fetch({
    url: PAGE_PUBLISH,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-取消发布
function pageCancelPublished(requestData, userName) {
  return fetch({
    url: PAGE_CANCEL_PUBLISHED,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 列表页-定时发布
function pageScheduledPublish(requestData, userName) {
  return fetch({
    url: PAGE_SCHEDULED_PUBLISH,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 编辑页-置为草稿状态
function pageDraft(requestData, userName) {
  return fetch({
    url: PAGE_DRAFT,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 编辑页-提审
function pageAudit(requestData, userName) {
  return fetch({
    url: PAGE_AUDIT,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 发布前-存在冲突的产品型号
function getPublishPageByProduct(requestData) {
  return fetch({
    url: GET_PUBLISH_PAGE_BY_PRODUCT,
    method: 'post',
    data: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

// 编辑页-发布
function pagePublishByEdit(requestData, userName) {
  return fetch({
    url: PAGE_PUBLISH_EDIT,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 编辑页-取消发布
function pageCancelPublishedByEdit(requestData, userName) {
  return fetch({
    url: PAGE_CANCEL_PUBLISHED_EDIT,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 编辑页-定时发布
function pageScheduledPublishByEdit(requestData, userName) {
  return fetch({
    url: PAGE_SCHEDULED_PUBLISH_EDIT,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json',
      'currentUserId': userName,
    },
    testerUrl: '/test/'
  });
};

// 页面管理-审核详情
function checkDetail(requestData) {
  return fetch({
    url: CHECK_DETAIL,
    method: 'get',
    params: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};

// 页面管理-查询商品类别
function pageGetCategoryList(requestData, userName) {
  return fetch({
    url: PAGE_GET_CATEGORY_LIST,
    method: 'get',
    params: requestData,
    testerUrl: '/test/'
  });
};

// 页面管理-查询商品列表
function pageGetProductList(requestData, userName) {
  return fetch({
    url: PAGE_GET_PRODUCT_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章类别
function pageGetArticleList(requestData, userName) {
  return fetch({
    url: PAGE_GET_ARTICLE_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章推荐
function pageGetArticleRecommended(requestData, userName) {
  return fetch({
    url: ARTICLE_RECOMMENDED,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章列表
function pageGetArticleDetail(requestData, userName) {
  return fetch({
    url: PAGE_GET_ARTICLE_DETAL,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章类别
function pageDetail(requestData, userName) {
  return fetch({
    url: PAGE_DETAIL,
    method: 'get',
    params: requestData,
    testerUrl: '/test/'
  });
};

// 页面管理-获取品牌
function getDcpBrand(requestData) {
  return fetch({
    url: GET_DCP_BRAND,
    method: 'get',
    params: requestData,
    testerUrl: '/test/'
  });
};

// 页面管理-文章列表
function pageGetNavList(requestData, userName) {
  return fetch({
    url: PAGE_GET_NAV_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章列表
function dcpArticleList(requestData, userName) {
  return fetch({
    url: DCP_ARTICLE_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-专题列表
function dcpSpecialTopicList(requestData, userName) {
  return fetch({
    url: DCP_SPECIAL_TOPIC_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-专题文章列表
function dcpTopicArticleList(requestData, userName) {
  return fetch({
    url: DCP_TOPIC_ARTICLE_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章列表
function getDcpAccountList(requestData, userName) {
  return fetch({
    url: DCP_ACCOUNT_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// 页面管理-文章列表
function getDcpDepartmentList(requestData, userName) {
  return fetch({
    url: DCP_DEPARTMENT_LIST,
    method: 'post',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    },
    testerUrl: '/test/'
  });
};

// ------页面管理---end

const marketingMgr = {
  getDcpDepartmentList,
  getDcpAccountList,
  dcpArticleList,
  dcpSpecialTopicList,
  dcpTopicArticleList,
  pageGetNavList,
  pageUpdate,
  pageDetail,
  getDcpBrand,
  pageList,
  userCategoryList,
  pageOperate,
  pageCopy,
  pageInvalid,
  pageDelete,
  pagePublish,
  pageCancelPublished,
  pageScheduledPublish,
  pageDraft,
  pageAudit,
  pagePublishByEdit,
  getPublishPageByProduct,
  pageCancelPublishedByEdit,
  pageScheduledPublishByEdit,
  checkDetail,
  pageGetArticleDetail,
  pageGetArticleRecommended,
  pageGetArticleList,
  pageGetProductList,
  pageGetCategoryList,
  pageAdd,
  pageGetAssemblyList,
  pageGetTemplateList,
  exchangeOrderList,
  exchangeOrderDetail,
  exchangeChangeOrderStatus,
  exchangeGetLoginsticsList,
  exchangeGoodsList,
  addExchangeGoods,
  goodsDetail,
  updateGoodsStatus,
  updateExchangeGoods,
  thirdPartyGiftsList,
  updateGoodsStatusBatch,
  // 广告
  editAdSubmit,
  editAdSubmitLast,
  dictSelectList,
  comboData,
  DD_VALUE_GET_AD_LIST,
  getAdList,
  getAdDetail,
  deleteAd,
  updateAdStatus,
  getAdDetailByPosition,
  updateBannerStatus,
  deleteBanner,
  // 新品试用
  getProductActivityList,
  getProductActivityListMidea,
  productActivityIntroduced,
  productActivityIntroducedMidea,
  getProductActivityDetail,
  getProductActivityDetailMidea,
  productActivityUpdate,
  productActivityUpdateMidea,
  deletedProductActivity,
  deletedProductActivityMidea,
  getProductOrderList,
  productOrderDeliver,
  productActivityReport,
  productOrderEvaluate,
  productOrderExamine,
  getQuestionsByid,
  reportDeletedByid,
  getReportGetByid,
  // 短链管理
  getShortLinkList,
  saveShortLink,
  deleteShortLink,
  getShortLinkDetail,
  getPvUvData,
  getPvUvTotalData,
  getPvUvWithGroupBy,
  // 短信管理
  getSmsList,
  smsDelById,
  smsGetEventDetail,
  smsGetOrgMsg,
  testSmsSend,
  smsSubmit,
  smsGetgroupList,
  smsFirstMobile,
  stopSendTaskInfo,
  // 短信模板
  getTemplateList,
  templateSaveOrUpdate,
  templateDetail,
  templateDelete,
  getTemplateVariableList,
  // 消息中心
  getMsgCenterList,
  getMsgChannelList,
  createMsg,
  editMsg,
  sendMsg,
  deleteMsg,
  getMsgDetail,
  // 微信模板消息
  getUpkeepConfigList,
  // 优惠券管理
  getCouponRuleList,
  getCouponRuleDetail,
  createCouponRule,
  optCreateCouponRule,
  editCouponRule,
  optEditCouponRule,
  getCouponActivityList,
  updateCouponActivityStatus,
  getCouponActivityDetail,
  createCouponActivity,
  editCouponActivity,
  getCouponOrderList,
  sendCouponOrder,
  getCouponOrderDetail,
  couponCancel,
  // 受众管理
  selectLabelList,
  insertOrUpdateLabelInfo,
  getLabelInfo,
  deleteLabelInfo,
  // 受众人群详情报表
  labelBoardTrend,
  labelBoardList,
  labelBoardSourceDistributed,
  labelBoardLevelDistributed,
  getCmimpGameList,
  getProductTypeXyj,
  // 引用大数据人群
  selectOdsGroupList,
  syneOdsGroup,
  // 投放效果报表
  promoteBoardOverview,
  getEventTree,
  getFunnelSteps,
  funnelSettingSave,
  funnelSettingDelete,
  funnelSettingList,
  funnelConversionRate,
  funnelTendency,
  funnelAllOverview,
  funnelAllOverviewChart,
  promoteTaskPage,
  daGetEvents,
  // 精准投放管理
  precisionPromotePage,
  precisionPromoteList,
  precisionPromoteDetail,
  precisionPromoteAdd,
  precisionPromoteDelete,
  precisionPromoteChannel,
  getPrecisionAdList,
  getPredictLabelCount,
  getPredictBeginTime,
  selectPromoteLabel,
  insertOrUpdateLabelType,
  getLabelRelation,
  selectLabelTypeList,
  deleteLabelType,
  insertOrUpdateLabelRelation,
  getMsgTemplateList,
  addMasterSlaveRule,
  // 自动化营销策略
  getMaterialList,
  precisionPromoteUpdateEnableStatus,
  getAchieveTotalNum,
  getAchieveChartLine,
  // 图文专题
  getPicTopicList,
  addPicTopic,
  updatePicTopicStatus,
  getPicTopicDetail,
  savePicTopicImage,
  getMaterialsPage,
  deleteMaterial,
  deleteMaterialType,
  editOrUpdateMaterial,
  editMaterialType,
  // 推送管理
  savePushMsg,
  updatePushMsg,
  commitAdvMsgAdd,
  commitAdvMsgEdit,
  commitPushMsgAdd,
  commitPushMsgEdit,
  deletePushMsg,
  invalidPushMsg,
  listPushMsg,
  getPushMsg,
  pushAppMsg,
  pushAppMsgEdit,
  getCrowdList,
  loadTagUserAdd,
  loadTagUserEdit,
  savaTargetAuditor,
  pushUserCount,
  // 广告(位)管理
  getAdvPositionList,
  advPositionDelete,
  advPositionUpdate,
  advPositionAdd,
  advPositionList,
  getAdvDetail,
  advAdd,
  savaTargetGgAuditor,
  advDelete,
  advUpdate,
  updateAdWeight,
  directionalToMobile,
  getUpdatedLog,
  advertisementCopy,
  queryAdvList,
  getAdvList,
  queryAdvOrderList,
  queryAdvPosList,
  advReviewStop,
  getAdvPosDetail,
};

export { marketingMgr };
